import { SANDBOX_PRESET_DEFINITIONS } from './sandbox/presets'
import { SANDBOX_PRESET_TAG, SANDBOX_PRESET_TAG_LIST, type SandboxPresetTag } from './sandbox/presetTags'
import { SANDBOX_PRESET_BODY_CSS, type SandboxComponentPreset } from './sandboxPresetTypes'

export type { SandboxComponentPreset, SandboxPresetTag }
export { SANDBOX_PRESET_TAG, SANDBOX_PRESET_TAG_LIST }
export { SANDBOX_PRESET_BODY_CSS }

/** Query parameter for `/tools/sandbox?preset=<id>` deep links. */
export const SANDBOX_PRESET_QUERY_PARAM = 'preset'

export function sandboxHrefWithPreset(presetId: string): string {
  const q = new URLSearchParams({ [SANDBOX_PRESET_QUERY_PARAM]: presetId })
  return `/tools/sandbox?${q.toString()}`
}

/** Full URL for sharing (e.g. Copy link). Uses `window.location.origin` in the browser. */
export function absoluteSandboxUrlWithPreset(presetId: string): string {
  const path = sandboxHrefWithPreset(presetId)
  if (typeof globalThis.window === 'undefined') return path
  return new URL(path, globalThis.window.location.origin).href
}

const PRESET_BY_ID = new Map<string, SandboxComponentPreset>()

export function getSandboxPresetById(id: string): SandboxComponentPreset | undefined {
  return PRESET_BY_ID.get(id)
}

export const SANDBOX_COMPONENT_PRESETS: SandboxComponentPreset[] = SANDBOX_PRESET_DEFINITIONS.map((preset) => {
  PRESET_BY_ID.set(preset.id, preset)
  return preset
})
